import { useModelContext } from '@app/contexts/model';
import { UserData } from '@app/models/Users.model';
import { UserPassword } from '@app/modules/SelfConfig/components/EditUserWindow/views/UserPassword';
import { useStorageUserListContext } from '@app/modules/SelfConfig/contexts/storage';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';
import { CanSaveTranslation } from './views/CanSaveTranslation';
import { LanguageChoice } from './views/LanguageChoice';
import { SaveUser } from './views/SaveUser';
import { UserLogin } from './views/UserLogin';

interface IEditUserWindowProps {}

export const EditUserWindow: FunctionComponent<IEditUserWindowProps> = observer<FunctionComponent<IEditUserWindowProps>>(function () {
    const { usersModel } = useModelContext();
    const { usersListStore } = useStorageUserListContext();

    function dataAssigner() {
        let data: UserData = {
            email: usersListStore.userLogin,
            password: usersListStore.userPassword != '' ? usersListStore.userPassword : void 0,
            language_source: usersListStore.mainLanguagesChosenIdSet,
            language_target: usersListStore.targetLanguagesChosenIdSet,
            approval: usersListStore.canSaveTranslation,
            privilege: usersListStore.userPrivilege === 'admin' ? 'admin' : 'user'
        };

        return data;
    }

    const sendFormData = (e) => {
        e.preventDefault();
        let singleUserEdit = dataAssigner();
        usersModel.updateUser(usersListStore.editedUserID, singleUserEdit).then(
            (v) => {
                usersListStore.editedUserID = '';
                usersListStore.handleClose();
                return usersModel.findUser();
            },
            (reason) => {
                usersListStore.handleOpenAlert();
            }
        );
    };

    return (
        <form onSubmit={sendFormData}>
            <Stack spacing={1}>
                <UserLogin />
                <UserPassword />
                <LanguageChoice />
                <CanSaveTranslation />
                <SaveUser />
            </Stack>
        </form>
    );
});
